import React, { useMemo } from 'react';

import { Separator } from 'craft/components/SelectedToolbar';
import { useTooltipChildren } from 'craft/components/Tooltip';
import { FloatingMenuTabContext } from 'craft/containers/FloatingMenu';
import { TabContext } from 'craft/containers/TooltipFloatingMenu';

import { DeleteTooltipButton } from './DeleteTooltipButton';
import { DuplicateTooltipButton } from './DuplicateTooltipButton';
import { ReorderTooltipButton } from './ReorderTooltipButton';

interface Props {
  tooltipTabContext: TabContext;
  menuPosition: 'top' | 'bottom';
}

export const TooltipTabContextMenu = ({ tooltipTabContext, menuPosition }: Props) => {
  const tooltips = useTooltipChildren();

  const tooltipPlacement = useMemo(() => (menuPosition === 'top' ? 'bottom' : 'top'), [
    menuPosition,
  ]);

  const { id, index, dom } = tooltipTabContext;

  const canDelete = tooltips.length > 1;
  const canMoveLeft = tooltips.length > 1 && index > 0;
  const canMoveRight = tooltips.length > 1 && index < tooltips.length - 1;

  return (
    <FloatingMenuTabContext dom={dom} menuPosition={menuPosition}>
      <DuplicateTooltipButton nodeId={id} tooltipPlacement={tooltipPlacement} />
      <DeleteTooltipButton nodeId={id} disabled={!canDelete} tooltipPlacement={tooltipPlacement} />
      <Separator />
      <ReorderTooltipButton
        nodeId={id}
        index={index}
        direction="left"
        disabled={!canMoveLeft}
        tooltipPlacement={tooltipPlacement}
      />
      <ReorderTooltipButton
        nodeId={id}
        index={index}
        direction="right"
        disabled={!canMoveRight}
        tooltipPlacement={tooltipPlacement}
      />
    </FloatingMenuTabContext>
  );
};
